import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import Box from "../Box";
import { HeaderWrapper } from "../../pages/ConfirmBookingStatus";
import ConfirmRequestAccordion from "../../pages/ConfirmBookingStatus/ConfirmRequestAccordion";
import dayjs from "dayjs";
import { isValidUrl } from "../../helper";

const OtherTripDetails = ({ data }) => {
  return (
    <>
      <HeaderWrapper>
        <TextFont fontColor={Colors.white} fontSize="1.5rem" fontWeight="600">
          Travel Cost Details
        </TextFont>
      </HeaderWrapper>
      <div
        style={{
          padding: "1.2rem",
          boxSizing: "border-box",
          background: Colors.white,
          borderRadius: "1rem",
        }}
      >
        <ColumnWrapper>
          <Item >
            <Header>Company Name</Header>
            <Value>{data?.costBorneBy?.companyName}</Value>
          </Item>
          <Item>
            <Header>Company Code</Header>
            <Value>{data?.costBorneBy?.companyCode}</Value>
          </Item>
          <Item>
            <Header>Cost Center</Header>
            <Value>{data?.costCenter ? data?.costCenter : "NA"}</Value>
          </Item>
          <Item>
            <Header>Project ID</Header>
            <Value>{data?.projectId ? data?.projectId : "NA"}</Value>
          </Item>
          <Item>
            <Header></Header>
            <Value></Value>
          </Item>
        </ColumnWrapper>
      </div>
    </>
  );
};

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Item = styled.div`
  width: ${(props) => (props.width ? props.width : "20%")};
    @media (max-width: 1024px) {
    width: 33.33%;
  }

  @media (max-width: 768px) {
    width: 50%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const WideItem = styled.div`
  width: 100%;
`;

const Header = styled.div`
  color: rgb(142, 142, 161);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const Value = styled.div`
  color: rgb(34, 36, 44);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export default OtherTripDetails;
